"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExercisePlayer = void 0;
const react_1 = __importDefault(require("react"));
const exercise_1 = require("@components/container/exercise");
const components_1 = require("@app/routes/SpeechDevelopment/components");
const quantityGame_1 = __importDefault(require("@components/quantity/quantityGame"));
const ExercisePaginations_1 = require("@app/routes/SpeechDevelopment/components/ExercisePaginations");
const ExerciseControls_1 = require("@app/routes/SpeechDevelopment/components/ExerciseControls");
const useWindowWidrh_1 = __importDefault(require("@hooks/useWindowWidrh"));
function ExercisePlayer({ exerciseCard, content: Content, }) {
    const windowWidth = (0, useWindowWidrh_1.default)();
    const { handleAnswer, answersFrameArray, card, coinCounts: { coinCount, rubyCount, diamondCount }, isStarted, isPaused, exHandler, } = exerciseCard;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(exercise_1.ContainerExercise, null,
            react_1.default.createElement(exercise_1.ExerciseWrapper, { wihMargin: windowWidth <= 1200 },
                react_1.default.createElement(components_1.DropContainerWrapper, null,
                    react_1.default.createElement(Content, { card: card, handleAnswer: handleAnswer, isStarted: isStarted, isPaused: isPaused, exHandler: exHandler }),
                    react_1.default.createElement(quantityGame_1.default, { diamondCount: diamondCount, rubyCount: rubyCount, goldCoin: coinCount })),
                react_1.default.createElement(ExercisePaginations_1.ExercisePagination, { answersFrameArray: answersFrameArray })),
            react_1.default.createElement(ExerciseControls_1.ExerciseControls, Object.assign({}, exerciseCard)))));
}
exports.ExercisePlayer = ExercisePlayer;
